import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  updateRoomFacilitiesDetails,
  getRoomFacilitiesDetailsWithId,
  getFacilityTypes,
} from "adminApi/RoomFaciliteDetailsApi/RoomFacilites";
import { validateForm } from "utils/validation";
import { RoomFacilityDetailRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditRoomFacilityDetailForm from "./Componates/EditRoomFacilityDetailForm";
import fields from "../json/RoomFacilityDetailFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";

const EditRoomFacilityDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});
  delete initialValues.imagePreview;

  const { values, errors, handleChange, handleFileChange, setValues, setErrors } = useFormChange(
    initialValues,
    RoomFacilityDetailRules
  );

  // Fetch existing record by ID and populate form
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    getRoomFacilitiesDetailsWithId,
    setValues
  );

  // Fetch facility types for the select dropdown
  const { data: facilityTypeOptions, loading: loadingTypes } = useFetchAllData(getFacilityTypes);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await updateRoomFacilitiesDetails({ id, data: formData });
    },
    (vals) => {
      // Copy before mutating to avoid modifying the original state object
      const v = { ...vals };
      if (typeof v.image === "string") delete v.image;
      delete v.imagePreview;
      const err = validateForm(v, RoomFacilityDetailRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Room Facility Detail updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit || loadingTypes) && <Spinner isSpinner={true} />}
      <EditRoomFacilityDetailForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        facilityTypeOptions={facilityTypeOptions || []}
        imagePreview={values.imagePreview || values.image}
        title="Update Room Facility Detail"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default EditRoomFacilityDetail;
